import { SigninCard } from "../../components";

const SignIn = () => {
  return <SigninCard />;
};

export { SignIn };
